import React from 'react';
import FooterContent from './FooterContent';

export default function Footer() {
    return (
        <footer className="relative md:sticky md:bottom-0 left-0 right-0 z-10 md:h-[80vh] bg-gradient-to-t from-[#D48937] to-[#D4AF37]/60">
            <FooterContent />
        </footer>
    );
}